import React from 'react';
import { getActivityTypeIcon } from '../utils/iconUtils';

interface InlineActivityFormProps {
  activity: {
    title: string;
    type: string;
    description: string;
  };
  onChange: (activity: any) => void;
  onSave: () => void;
  onCancel: () => void;
  isSaving: boolean;
}

const InlineActivityForm: React.FC<InlineActivityFormProps> = ({
  activity,
  onChange,
  onSave,
  onCancel,
  isSaving
}) => {
  const activityTypes = [
    { value: 'lesson', label: 'Bài học' },
    { value: 'quiz', label: 'Kiểm tra' },
    { value: 'exercise', label: 'Bài tập' },
    { value: 'session', label: 'Buổi học' },
    { value: 'assignment', label: 'Bài tập lớn' }
  ];

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      ...activity,
      [e.target.name]: e.target.value
    });
  };

  const handleSave = (e: React.MouseEvent) => {
    e.stopPropagation();
    onSave();
  };

  const handleCancel = (e: React.MouseEvent) => {
    e.stopPropagation();
    onCancel();
  };

  return (
    <div 
      className="mt-2 bg-white border border-blue-200 rounded-md p-2 shadow-sm"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex items-center space-x-2">
        <div className="flex items-center">
          <div className="mr-2">
            {getActivityTypeIcon(activity.type)}
          </div>
          <span className="text-xs text-gray-600">
            {activityTypes.find(t => t.value === activity.type)?.label}
          </span>
        </div>
        <input
          type="text"
          name="title"
          value={activity.title}
          onChange={handleChange}
          placeholder="Tên hoạt động"
          className="flex-1 block text-sm border border-gray-300 rounded-md shadow-sm py-1 px-2 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          autoFocus
          maxLength={50}
          onClick={(e) => e.stopPropagation()}
        />
      </div>
      <div className="mt-2 flex justify-end space-x-2">
        <button
          onClick={handleCancel}
          disabled={isSaving}
          className="text-xs py-1 px-2 text-gray-600 hover:text-gray-800"
        >
          Hủy
        </button>
        <button
          onClick={handleSave}
          disabled={isSaving || !activity.title.trim()}
          className={`text-xs py-1 px-3 rounded ${
            isSaving || !activity.title.trim() 
              ? 'bg-blue-300 text-white cursor-not-allowed' 
              : 'bg-blue-600 text-white hover:bg-blue-700'
          }`}
        >
          {isSaving ? 'Đang lưu...' : 'Thêm'}
        </button>
      </div>
    </div>
  );
};

export default InlineActivityForm; 